export * from './lib/recent-activities.module';
export * from './lib/recent-activities.component';
